<script setup lang="ts">
const title = 'Блог';

useMeta(() => ({
  title,
}));

const { articles$ } = useFindArticles();
// const router = useRouter();
</script>

<template lang="pug">
q-page()
  SectionWrap
    ContainerWrap
      TitleH2().alegreya.italic.mb-16 {{ title }}
      .articles().row.q-col-gutter-md
        .col-12.col-md-4(
          v-for="(item, i) in articles$.data"
          :key="`events-view-list-item-${i+1}`")
          ArticleCard(:article="item").h-full
      //- .toolbar.row.justify-center.my-4
        q-pagination(
          :model-value="articles$.currentPage"
          :max="articles$.pageCount"
          :max-pages="8"
          outline
          active-design="unelevated"
          direction-links
          color="grey"
          active-color="primary"
          @update:model-value="articles$.toPage($event)")
</template>
